import React, { useState, useRef, useEffect } from "react";
import axios from 'axios';
import { Cookies } from '../../index.js';
import { RingLoader } from "react-spinners";
import { alert_error, alert_success } from "../../AppContext.js";
import Getlink from './Getlink';
import { Helmet } from "react-helmet";
import BitmediaAd from './bitmedia';
import { useNavigate } from "react-router-dom";
import { FaPlus, FaUser } from 'react-icons/fa';
import Editinfotask from './infotask_edit.jsx';
import Editor from './infotask_editor.jsx';
function Faucettraffic() {
    const [level, setlevel] = useState('');
    const [dalaythongtin, setdalaythongtin] = useState(false);
    const [data, setdata] = useState('');
    const [nutxuly, setnutxuly] = useState(0);
    const [service, setservice] = useState("");
    const [mission, setmisson] = useState('');
    const [contact, setcontact] = useState('');
    const [nutorder, setnutorder] = useState();
    const [dataToSend, setdataToSend] = useState(false);
    const [link, setlink] = useState(false);
    const [showedit, setshowedit] = useState(false);
    const [showditor, setshowditor] = useState(false);
    const navigate = useNavigate();
    const national_market = Cookies.get('national_market') || 'vi';
    function switch_router(id) {
        const link = '/reactapp/infotask/' + id;
        console.log(link);
        navigate(link);
    };
    function handleSubmit(value) {
        console.log(value);
        laymisson(value);
        setdataToSend(false);
        setservice(value);
        setnutorder('Xác thực bạn không phải người máy nhé');
        setTimeout(() => {
            showcaptcha(value);
        }, 300);

    };
    useEffect(() => {
        const myCookieValue = Cookies.get('apikey');
        axios.get('https://hust.media/jop/telegram/checkxacthuc.php?apikey=' + myCookieValue + '&chedo=' + 'addusers')
            .then((response) => {
                testFunction(response);
                if (response.data.contact) {
                    setcontact(response.data.contact);
                }
            })
            .catch((error) => {
                alert_error(error);
            });
    }, []);
    function updateJson1(json1, json2) {
        json2.forEach(item2 => {
            const index = json1.findIndex(item1 => item1.id === item2.id);

            if (index !== -1) {
                // Nếu tìm thấy trùng id, cập nhật toàn bộ thông số
                json1[index] = item2;
            } else {
                // Nếu không tìm thấy, thêm vào mảng
                json1.push(item2);
            }
        });

        return json1;
    }
    function laymisson(value) {

        setmisson(false);
        const myCookieValue = Cookies.get('apikey');
        if (value === undefined) {
            axios.get('https://hust.media/jop/mission/checkapp.php', {
                params: {
                    apikey: myCookieValue,
                    category: service
                }
            })
                .then(response => {
                    console.log(response.data); // Dữ liệu từ API
                    // Cập nhật JSON 1 từ JSON 2
                    const updatedJson1 = updateJson1(data, response.data);
                    setdata(updatedJson1);
                    // console.log(updatedJson1);
                    setdalaythongtin(true);
                    // Xử lý dữ liệu ở đây
                })
                .catch(error => {
                    alert_error(error);
                });
        } else {
            axios.get('https://hust.media/jop/mission/checkapp.php', {
                params: {
                    apikey: myCookieValue,
                    category: value
                }
            })
                .then(response => {
                    console.log(response.data); // Dữ liệu từ API
                    // Cập nhật JSON 1 từ JSON 2
                    const updatedJson1 = updateJson1(data, response.data);
                    setdata(updatedJson1);
                    // console.log(updatedJson1);
                    setdalaythongtin(true);
                    // Xử lý dữ liệu ở đây
                })
                .catch(error => {
                    alert_error(error);
                });
        }

    };
    function laythongtin() {
        setdalaythongtin(false);
        setmisson(false);
        const myCookieValue = Cookies.get('apikey');
        axios.get('https://hust.media/jop/mission/checkapp.php', {
            params: {
                apikey: myCookieValue
            }
        })
            .then(response => {
                console.log(response.data); // Dữ liệu từ API
                setdata(response.data);
                setdalaythongtin(true);
                // Xử lý dữ liệu ở đây
            })
            .catch(error => {
                alert_error(error);
            });
    };
    const startjop = (event) => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
                laymisson();
            } else {
                // do something when the tab becomes hidden
            }

        };
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {

        };
    }
    useEffect(() => {
        laythongtin();
    }, []);
    function showcaptcha(value) {
        setdataToSend(true);
    };
    const receiveDataFromChild = (dataFromChild) => {
        // Xử lý dữ liệu từ component con
        console.log("Received data from child:", dataFromChild);
        const maxLength = 200;

        if (dataFromChild.length > maxLength) {
            setnutxuly(1);
            setnutorder('Bạn hãy đợi vài giây để app xử lý nhé');
            const myCookieValue = Cookies.get('apikey');
            let data = JSON.stringify({
                "recaptchaValue": dataFromChild,
                "service": service,
                "apikey": myCookieValue,
                "national_market": national_market
            });
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://nginx.hust.media/go/mission/p2p_link/getlink',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios.post(config.url, config.data, config.headers)
                .then((response) => {
                    setnutxuly(0);
                    testFunction(response);
                })
                .catch((error) => {
                    setnutxuly(0);
                    alert_error(error);
                });
        }
        // Cập nhật state trong component cha nếu cần
        // setdataToSend(dataFromChild);
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;

        setnutxuly(0);

        if (status == 1) {
            alert_success(message);
            setnutorder('Cảm ơn bạn đã ủng hộ');
            setmisson(true);
            setlink(info.link);
        }
        else if (status == 0) {
            setnutorder(message);
            alert_error(message);
        }
        else {
            setnutorder('Đã xảy ra lỗi vui lòng nhập lại');
            alert_error('Đã xảy ra lỗi vui lòng nhập lại');
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
        if (info.level) {
            setlevel(info.level);
        }
    };
    const handleEditClick = () => {
        // Gọi hàm onEditClick từ component cha khi nút chỉnh sửa được nhấp
        edit();
    };
    function edit() {
        if (level != 'editor') {
            alert_error('User chỉnh sửa mới được chỉnh thông số');
        }
        else {
            setshowedit(true);
        }
    };
    function loadtask() {
        laythongtin();
    };
    return (

        <div className=" overflow-x-hidden w-full rounded-lg shadow-xl px-2  max-w-screen-xl mx-auto">
            {/* <BitmediaAd /> */}
            {!dalaythongtin ? (<div className="flex justify-center items-center">
                <RingLoader size={80} color="#0000ff" />{" "}
            </div>
            ) : (<>    {
                data &&
                (
                    <>
                        {/* <div id="M882924ScriptRootC1520508"></div>
                        <Helmet>
                            <script src="https://jsc.adskeeper.com/h/u/hust.media.1520508.js" async></script>
                        </Helmet> */}
                        {showedit ? (
                            <>
                                <Editinfotask showedit={showedit} setshowedit={setshowedit} loadtask={loadtask} />
                            </>
                        ) : showditor ? (
                            <>
                                <Editor showditor={showditor} setshowditor={setshowditor}
                                    contact={contact} setcontact={setcontact} />
                            </>
                        ) : null}

                        {level == 'editor'
                            &&
                            (<>
                                <div className="flex items-center">
                                    <div onClick={() => setshowditor(true)} className="mr-auto"> {/* Căn bên trái */}
                                        Sửa liên hệ <FaUser className="" />
                                    </div>
                                    <div className="ml-auto" onClick={() => handleEditClick()} > {/* Căn bên phải */}
                                        Thêm jop mới <FaPlus />
                                    </div>
                                </div>
                            </>)}
                        <div className="  flex flex-wrap ">

                            {data.map((item, index) => (
                                <>

                                    <div key={index} className={`mb-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 p-3 ${index > 0 && index % 4 === 0 ? 'clear-left' : ''}`}>
                                        {/* <div className=" ">
                                        <iframe
                                            data-aa="2271984"
                                            src="//ad.a-ads.com/2271984?size=320x50"
                                            frameBorder="0"
                                            scrolling="no"
                                            allowFullScreen
                                            style={{
                                                width: '320px',
                                                height: '50px',
                                                border: 0,
                                                padding: 0,
                                                overflow: 'hidden',
                                                backgroundColor: 'transparent'
                                            }}
                                        ></iframe>
                                    </div> */}
                                        <div className="border p-3 rounded-lg bg-white shadow-lg">
                                            <button
                                                disabled={nutxuly == 1}
                                                onClick={() => switch_router(item.id)}
                                                className="flex justify-between items-center mb-2 w-full">
                                                <>
                                                    <img src={item.img} alt="Mô tả ảnh" className="h-14 w-14 text-white" />
                                                </>
                                                <p className="font-bold text-xl">{item.name}</p>
                                            </button>
                                            <button
                                                onClick={() => switch_router(item.id)}
                                                className="flex justify-between items-center mb-2 w-full">
                                                <p className="fb-3 text-gray-700">{item.description}</p>
                                                {/* <p className="font-bold text-lg">{item.id}</p> */}
                                                <div className="rounded-full bg-pink-500 p-2">
                                                    <>
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                                                        </svg></>
                                                </div>
                                            </button>

                                            <div className="border-t border-gray-300 my-2"></div>
                                            <div className="grid grid-cols-3 gap-4 items-center">
                                                <div className="mb-0 inline-block">
                                                    <span>🌾</span>
                                                    <span className="text-lg font-semibold text-blue-600 block">
                                                        {Math.round(+item.price / 100 * +item.received / 10) * 10} Coins
                                                    </span>
                                                </div>
                                                <div className="text-sm text-gray-600 mb-0 inline-block">
                                                    🌲 {item.limit}% hạn mức
                                                </div>
                                                <div className="text-sm text-gray-600 mb-0 inline-block">
                                                    🕑 {item.time} ngày
                                                </div>

                                            </div>

                                            {
                                                service == item.id &&
                                                (
                                                    <>
                                                        {mission ? (<>   <div className="flex items-center justify-center">
                                                            <a href={link} target="_blank" >
                                                                <button onClick={(event) => startjop(event)} className="bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-lg transform hover:scale-105 transition duration-300 ease-in-out">
                                                                    Try Now
                                                                </button>
                                                            </a>
                                                        </div></>) :

                                                            (
                                                                <><div className="mt-0">
                                                                    {nutorder}
                                                                    <Getlink data={dataToSend} sendDataToParent={receiveDataFromChild} />
                                                                </div></>

                                                            )

                                                        }

                                                    </>

                                                )
                                            }

                                            {/* <Getlink /> */}
                                        </div>

                                    </div>
                                </>

                            ))}
                        </div>

                    </>
                )
            }</>)}


        </div>
    );
}

export default Faucettraffic;
